import { Button, Card, Flexbox, FormField, TextInput } from "@sede-x/shell-ds-react-framework";
import { useState } from "react";

const NoSsoLogin = ({ onLogin }: { onLogin: () => void }) => {
  const [userName, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  return (
    <Flexbox alignItems="center" style={{ width: "100vw", height: "100vh" }}>
      <Card style={{ width: "300px", margin: "auto" }}>
        <form
          onSubmit={event => {
            event.preventDefault();
            localStorage.setItem("NO_SSO_TOKEN", btoa(`${userName}:${password}`));
            onLogin();
          }}>
          <FormField size={"medium"} label="User Name">
            <TextInput
              onChange={event => setUserName(event.target.value.trim())}
              value={userName}
              required
              minLength={4}
            />
          </FormField>
          <FormField size={"medium"} label="Password">
            <TextInput
              onChange={event => setPassword(event.target.value.trim())}
              value={password}
              required
              minLength={4}
            />
          </FormField>
          <Button type="submit">Login</Button>
        </form>
      </Card>
    </Flexbox>
  );
};

export default NoSsoLogin;
